/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HorseSearchResultDto } from './HorseSearchResultDto';
import {
    HorseSearchResultDtoFromJSON,
    HorseSearchResultDtoFromJSONTyped,
    HorseSearchResultDtoToJSON,
    HorseSearchResultDtoToJSONTyped,
} from './HorseSearchResultDto';

/**
 * 
 * @export
 * @interface HorseSearchResponseDto
 */
export interface HorseSearchResponseDto {
    /**
     * 
     * @type {Array<HorseSearchResultDto>}
     * @memberof HorseSearchResponseDto
     */
    items?: Array<HorseSearchResultDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof HorseSearchResponseDto
     */
    hasMore?: boolean;
}

/**
 * Check if a given object implements the HorseSearchResponseDto interface.
 */
export function instanceOfHorseSearchResponseDto(value: object): value is HorseSearchResponseDto {
    return true;
}

export function HorseSearchResponseDtoFromJSON(json: any): HorseSearchResponseDto {
    return HorseSearchResponseDtoFromJSONTyped(json, false);
}

export function HorseSearchResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HorseSearchResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(HorseSearchResultDtoFromJSON)),
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
    };
}

export function HorseSearchResponseDtoToJSON(json: any): HorseSearchResponseDto {
    return HorseSearchResponseDtoToJSONTyped(json, false);
}

export function HorseSearchResponseDtoToJSONTyped(value?: HorseSearchResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(HorseSearchResultDtoToJSON)),
        'hasMore': value['hasMore'],
    };
}

